<template>
    <div>
        <form id="inviteUserForm" @submit.prevent="validateForm">
            <div class="form-group">
                <label>Invitee Name</label>
                <input type="text" name="inviteeName" data-vv-validate-on="blur" data-vv-as="invitee name" placeholder="Invitee Name"
                    v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('inviteeName')
                    }"
                    v-model="form.inviteeName">
                <div v-show="validationErrors.has('inviteeName')" class="invalid-feedback">
                    {{ validationErrors.first('inviteeName') }}
                </div>
            </div>

            <div class="form-group">
                <label>E-mail Address</label>
                <input type="text" name="emailAddress" data-vv-validate-on="blur" data-vv-as="e-mail address" placeholder="E-mail Address"
                    v-validate="'required|email'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('emailAddress')
                    }"
                    v-model="form.emailAddress">
                <div>
                    <small>Please enter the e-mail address for this invitation to be delivered to.</small>
                </div>
                <div v-show="validationErrors.has('emailAddress')" class="invalid-feedback">
                    {{ validationErrors.first('emailAddress') }}
                </div>
            </div>
            <p v-if="isSubmitMessageShown" :class="{'text-danger': isSubmitMessageError}" v-html="submitMessage">
            </p>
            <button type="button" @click="submitInviteRequest" class="btn btn-primary btn-primary-insv mr-2 mb-2">Invite User Now</button>
        </form>
    </div>
</template>

<script>
export default {
    'name': 'SingleUserInvite',
    data () {
        return {
            'form': {
                'inviteeName': '',
                'emailAddress': ''
            },
            'isSubmitMessageShown': false,
            'isSubmitMessageError': false,
            'submitMessage': ''
        };
    },
    'methods': {
        validateForm () {
            return this.$validator.validateAll();
        },
        submitInviteRequest () {
            this.validateForm().then((isValid) => {
                if (isValid) {
                    this.submitMessage = 'Creating new user invitation...';
                    this.isSubmitMessageShown = true;
                    this.isSubmitMessageError = false;

                    this.axios.post('/Invite/DoctorInviteNewUser', [{
                        'e': this.form.emailAddress,
                        'n': this.form.inviteeName
                    }]).then(({
                        data
                    }) => {
                        this.submitInviteHasError = false;
                        let successList = data.data.si;
                        let failedList = data.data.fi;

                        if (successList.length === 0 && failedList.length === 1) {
                            this.submitMessage = `Error creating user invitation. <br> ${failedList[0].fr}`;
                        } else {
                            this.submitMessage = `New invitation has been sent!`;

                            this.form.emailAddress = '';
                            this.form.inviteeName = '';

                            this.$nextTick(() => {
                                this.$emit('userInvited');
                                this.$validator.reset();
                            });
                        }

                        this.isSubmitMessageShown = true;
                        this.submitInviteHasError = true;
                    }).catch(() => {
                        this.isSubmitMessageShown = true;
                        this.submitInviteHasError = true;
                        this.submitMessage = 'Error creating user invitation. Please try again.';
                    });
                } else {
                    this.isSubmitMessageShown = true;
                    this.isSubmitMessageError = true;
                    this.submitMessage = 'There\'s error(s) in the form. Please check your input and try again.';

                    this.$nextTick(() => {
                        if (document.querySelector('#inviteUserForm .is-invalid')) {
                            document.querySelector('#inviteUserForm .is-invalid').focus();
                        }
                    });
                }
            });
        }
    }
};
</script>
